"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    propImg: [String],
    imageUrl: [String],
    worksInfo: [Object]
  },
  data: function data() {
    return {
      uploadFileUrl: process.env.VUE_APP_BASE_API + "/common/upload"
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.$emit("successUpLoad", res);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var types = file.name;
      var fileIndex = types.lastIndexOf(".") + 1;
      var workType = types.substring(fileIndex);
      console.log(workType, 'workType');
      var isLt2M = file.size / 1024 / 1024;
      var typeFlag = this.worksInfo.fileType.includes(workType);
      var sizeFlag = +this.worksInfo.size >= isLt2M;
      if (!typeFlag) {
        this.$message.error("当前作品项请上传" + this.worksInfo.fileType + "格式文件。");
        return false;
      } else if (!sizeFlag) {
        this.$message.error("当前作品项上传文件请勿超过" + this.worksInfo.size + "M。");
        return false;
      } else {
        return true;
      }
    }
  }
};